"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));

var _alloyReactModal = _interopRequireDefault(require("@adsk/alloy-react-modal"));

var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _qa = _interopRequireDefault(require("../../util/qa"));

var _MediaUploadBody = _interopRequireDefault(require("./MediaUploadBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledModal = (0, _styledComponents.default)(_alloyReactModal.default)`
  height: unset;
  width: 700px;
`;
const Title = _styledComponents.default.h1`
  font-size: 24px;
`;
const FooterButtons = _styledComponents.default.div`
  button {
    margin-left: 8px;
  }
`;
const FooterText = _styledComponents.default.div`
  padding-top: 8px;
`;
const Text = _styledComponents.default.span`
  color: ${_alloyReactTheme.default.colors.charcoal700};
  font-weight: 450;
  font-size: 14px;
  line-height: 20px;
`;
const LinkText = _styledComponents.default.a`
  margin-left: 8px;
  line-height: 20px;
  font-weight: 450;
  font-style: normal;
  color: ${_alloyReactTheme.default.colors.adskBlue700};
  &:hover {
    cursor: pointer;
  }
`;
const FooterContainer = _styledComponents.default.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const Header = ({
  closeHandler
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Title, null, T.translate("UPLOAD_PHOTOS_AND_VIDEOS")), /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Close, {
    onClick: closeHandler
  }));
};

const Footer = ({
  uploads,
  closeHandler,
  cancelHandler,
  clearHandler
}) => {
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  const completedUploads = uploads.filter(u => u.status === "complete");
  return /*#__PURE__*/_react.default.createElement(FooterContainer, null, /*#__PURE__*/_react.default.createElement(FooterText, null, completedUploads.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Text, null, T.translate("COUNT_UPLOADED", {
    context: completedUploads.length
  })), /*#__PURE__*/_react.default.createElement(LinkText, {
    onClick: clearHandler
  }, T.translate("CLEAR")))), /*#__PURE__*/_react.default.createElement(FooterButtons, null, cancelHandler && /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
    variant: _alloyReactButton.default.VARIANTS.TERTIARY,
    size: _alloyReactButton.default.SIZES.MEDIUM,
    onClick: cancelHandler
  }, T.translate("CANCEL")), /*#__PURE__*/_react.default.createElement(_alloyReactButton.default, {
    "data-qa": _qa.default.mediaUploadDoneButton,
    disabled: uploads.length === 0,
    size: _alloyReactButton.default.SIZES.MEDIUM,
    onClick: closeHandler
  }, T.translate("DONE"))));
};

const MediaUploadModal = ({
  closeHandler,
  removeHandler,
  uploadHandler,
  cancelHandler,
  renderHeader,
  renderFooter,
  uploads,
  clearHandler
}) => {
  const Head = (0, _react.useCallback)(() => renderHeader ? renderHeader({
    uploads,
    closeHandler
  }) : /*#__PURE__*/_react.default.createElement(Header, {
    uploads: uploads,
    closeHandler: closeHandler
  }), [renderHeader, uploads, closeHandler]);
  const Foot = (0, _react.useCallback)(() => renderFooter ? renderFooter({
    clearHandler,
    uploads,
    closeHandler,
    cancelHandler
  }) : /*#__PURE__*/_react.default.createElement(Footer, {
    uploads: uploads,
    closeHandler: closeHandler,
    cancelHandler: cancelHandler,
    clearHandler: clearHandler
  }), [clearHandler, cancelHandler, closeHandler, renderFooter, uploads]);
  return /*#__PURE__*/_react.default.createElement(StyledModal, {
    "data-qa": _qa.default.mediaUploadModal,
    onClose: closeHandler,
    open: true
  }, /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Header, null, /*#__PURE__*/_react.default.createElement(Head, null)), /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Body, null, /*#__PURE__*/_react.default.createElement(_MediaUploadBody.default, {
    uploadHandler: uploadHandler,
    uploads: uploads,
    removeHandler: removeHandler
  })), /*#__PURE__*/_react.default.createElement(_alloyReactModal.default.Footer, null, /*#__PURE__*/_react.default.createElement(Foot, null)));
};

var _default = MediaUploadModal;
exports.default = _default;